import { Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import rem from 'utils/rem'

const InventorySummaryItem = ({ label, value, additionalValue }) => (
  <Stack flex={1} p={1} alignItems="center">
    <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12) }} gutterBottom>
      {label.toUpperCase()}
    </Typography>
    <Typography align="center" gutterBottom={!!additionalValue}>
      {value === '' ? '---' : value}
    </Typography>
    {additionalValue && (
      <Typography color="textSecondary" align="center" sx={{ fontSize: rem(10) }}>
        {additionalValue}
      </Typography>
    )}
  </Stack>
)

InventorySummaryItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalValue: PropTypes.string,
}

InventorySummaryItem.defaultProps = {
  value: '',
  additionalValue: null,
}

const InventorySummaryBar = ({ items, isGrayBg }) => (
  <Stack
    py={1}
    sx={{ bgcolor: isGrayBg ? 'primary.lightBg' : 'white' }}
    direction="row"
    divider={<Divider orientation="vertical" flexItem />}
    borderBottom={1}
    borderColor="divider"
  >
    {items.map(item => (
      <InventorySummaryItem key={`inventory-summary-item-${item.label}`} {...item} />
    ))}
  </Stack>
)

InventorySummaryBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(InventorySummaryItem.propTypes)).isRequired,
  isGrayBg: PropTypes.bool,
}

InventorySummaryBar.defaultProps = {
  isGrayBg: true,
}

export default InventorySummaryBar
